import React, { useState } from "react";
import client from "@culturehq/client";
import { PlainButton } from "@culturehq/components";

import { useTryCatch } from "app/hooks";
import { Trans } from "app/utils";

import CircleCheck from "components/display/CircleCheck";

const saveEventRsvp = options => (
  client[options.rsvpId ? "updateEventRsvp" : "createEventRsvp"](options)
);

const QuickRSVP = ({ background, event, onRefreshCap }) => {
  const [rsvp, setRSVP] = useState(event.rsvpForUser || {});

  const [{ success }, onRSVP] = useTryCatch(
    async ({ target }) => {
      const response = await saveEventRsvp({
        responseType: target.dataset.value,
        eventId: event.id,
        rsvpId: rsvp.id
      });

      if (rsvp.responseType !== response.rsvp.responseType && onRefreshCap) {
        onRefreshCap(response.rsvp);
      }
      setRSVP(response.rsvp);
    },
    [event, rsvp, setRSVP]
  );

  return (
    <div className="QuickRSVP">
      <div className="actions clearfix">
        <PlainButton className="link-rsvp yes" onClick={onRSVP} data-value="accepted">
          {rsvp.responseType === "accepted" && (
            <CircleCheck animate={success} background={background} />
          )}
          <Trans> Yes</Trans>
        </PlainButton>
        <PlainButton className="link-rsvp interested" onClick={onRSVP} data-value="interested">
          {rsvp.responseType === "interested" && (
            <CircleCheck animate={success} background={background} />
          )}
          <Trans> Interested</Trans>
        </PlainButton>
      </div>
    </div>
  );
};

export default QuickRSVP;
